module.exports = __webpack_public_path__ + "static/media/happy.bdb18595.png";